import { Icon, TextLink, TextPassage } from '@petsmart-ui/sparky';

import './EarnedPoints.scss';

interface EarnedPointsProps {
    points: number;
}

export function EarnedPoints({ points }: EarnedPointsProps) {
    return (
        <div className="earned-points" data-testid="earned-points">
            <Icon
                size="md"
                name="treats-icon"
                className="sparky-u-margin-right-sm"
            />
            <TextPassage>{points} points earned</TextPassage>
            <TextLink className="view-points-link">View points</TextLink>
        </div>
    );
}
